import { render, staticRenderFns } from "./memnuniyet.vue?vue&type=template&id=382a8cef&"
import script from "./memnuniyet.vue?vue&type=script&lang=js&"
export * from "./memnuniyet.vue?vue&type=script&lang=js&"
import style0 from "./memnuniyet.vue?vue&type=style&index=0&id=382a8cef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports